export default {
  lang: 'fa',
  dir: 'rtl',
  common: {
    ok: '‫تأیید‬',
    cancel: '‫لغو‬',
    key_backspace: '‫پس بر ‬',
    key_del: '‫حذف ‬',
    key_down: '‫پایین ‬',
    key_up: '‫بالا ‬',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Show/hide more stroke tools',
    palette_info: '‫برای تغییر رنگ، کلیک کنید. برای تغییر رنگ لبه، کلید تبدیل (shift) را فشرده و کلیک کنید‬',
    zoom_level: '‫تغییر بزرگ نمایی‬',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Identify the element',
    fill_color: '‫تغییر رنگ‬',
    stroke_color: '‫تغییر رنگ لبه‬',
    stroke_style: '‫تغییر نقطه چین لبه‬',
    stroke_width: '‫تغییر عرض لبه‬',
    pos_x: '‫تغییر مختصات X‬',
    pos_y: '‫تغییر مختصات Y‬',
    linecap_butt: 'Linecap: Butt',
    linecap_round: 'Linecap: Round',
    linecap_square: 'Linecap: Square',
    linejoin_bevel: 'Linejoin: Bevel',
    linejoin_miter: 'Linejoin: Miter',
    linejoin_round: 'Linejoin: Round',
    angle: '‫تغییر زاویه چرخش‬',
    blur: 'Change gaussian blur value',
    opacity: '‫تغییر تاری عنصر انتخاب شده‬',
    circle_cx: '‫تغییر مختصات cx دایره‬',
    circle_cy: '‫تغییر مختصات cy دایره‬',
    circle_r: '‫تغییر شعاع دایره‬',
    ellipse_cx: '‫تغییر مختصات cx بیضی‬',
    ellipse_cy: '‫تغییر مختصات cy بیضی‬',
    ellipse_rx: '‫تغییر شعاع rx بیضی‬',
    ellipse_ry: '‫تغییر شعاع ry بیضی‬',
    line_x1: '‫تغییر مختصات x آغاز خط‬',
    line_x2: '‫تغییر مختصات x پایان خط‬',
    line_y1: '‫تغییر مختصات y آغاز خط‬',
    line_y2: '‫تغییر مختصات y پایان خط‬',
    rect_height: '‫تغییر ارتفاع مستطیل‬',
    rect_width: '‫تغییر عرض مستطیل‬',
    corner_radius: '‫شعاع گوشه:‬',
    image_width: '‫تغییر عرض تصویر‬',
    image_height: '‫تغییر ارتفاع تصویر‬',
    image_url: '‫تغییر نشانی وب (url)‬',
    node_x: '‫تغییر مختصات x نقطه‬',
    node_y: '‫تغییر مختصات y نقطه‬',
    seg_type: '‫تغییر نوع قطعه (segment)‬',
    straight_segments: '‫مستقیم‬',
    curve_segments: '‫منحنی‬',
    text_contents: '‫تغییر محتویات متن‬',
    font_family_label: 'Font:',
    font_family: '‫تغییر خانواده قلم‬',
    font_size: '‫تغییر اندازه قلم‬',
    bold: '‫متن توپر ‬',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: '‫متن کج ‬',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Main Menu',
    bkgnd_color_opac: '‫تغییر رنگ پس زمینه / تاری‬',
    connector_no_arrow: 'No arrow',
    fitToContent: '‫هم اندازه شدن با محتوا‬',
    fit_to_all: '‫هم اندازه شدن با همه محتویات‬',
    fit_to_canvas: '‫هم اندازه شدن با صفحه مجازی (بوم)‬',
    fit_to_layer_content: '‫هم اندازه شدن با محتوای لایه‬',
    fit_to_sel: '‫هم اندازه شدن با اشیاء انتخاب شده‬',
    align_relative_to: '‫تراز نسبت به ...‬',
    relativeTo: '‫نسبت به:‬',
    page: '‫صفحه‬',
    largest_object: '‫بزرگترین شئ‬',
    selected_objects: '‫اشیاء انتخاب شده‬',
    smallest_object: '‫کوچکترین شئ‬',
    new_doc: '‫تصویر جدید ‬',
    open_doc: '‫باز کردن تصویر ‬',
    export_img: 'Export',
    save_doc: '‫ذخیره تصویر ‬',
    import_doc: 'Import SVG',
    align_to_page: 'Align Element to Page',
    align_bottom: '‫تراز پایین‬',
    align_center: '‫وسط چین‬',
    align_left: '‫چپ چین‬',
    align_middle: '‫تراز میانه‬',
    align_right: '‫راست چین‬',
    align_top: '‫تراز بالا‬',
    mode_select: '‫ابزار انتخاب ‬',
    mode_fhpath: '‫ابزار مداد ‬',
    mode_line: '‫ابزار خط ‬',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: '‫مستطیل با قابلیت تغییر پویا‬',
    mode_ellipse: '‫بیضی‬',
    mode_circle: '‫دایره‬',
    mode_fhellipse: '‫بیضی با قابلیت تغییر پویا‬',
    mode_path: '‫ابزار مسیر ‬',
    mode_text: '‫ابزار متن ‬',
    mode_image: '‫ابزار تصویر ‬',
    mode_zoom: '‫ابزار بزرگ نمایی ‬',
    no_embed: 'NOTE: This image cannot be embedded. It will depend on this path to be displayed',
    undo: '‫واگرد ‬',
    redo: '‫ازنو ‬',
    tool_source: '‫ویرایش منبع ‬',
    wireframe_mode: '‫حالت نمایش لبه ها ‬',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: '‫قرار دادن عناصر در گروه ‬',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: '‫تبدیل به مسیر‬',
    reorient_path: '‫جهت دهی مجدد مسیر‬',
    ungroup: '‫خارج کردن عناصر از گروه ‬',
    docprops: '‫مشخصات سند ‬',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: '‫انتقال به پایین ترین ‬',
    move_top: '‫انتقال به بالاترین ‬',
    node_clone: '‫ایجاد کپی از نقطه‬',
    node_delete: '‫حذف نقطه‬',
    node_link: '‫پیوند دادن نقاط کنترل‬',
    add_subpath: 'Add sub-path',
    openclose_path: 'Open/close sub-path',
    source_save: '‫اعمال تغییرات‬',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'حذف',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: '‫لایه‬',
    layers: 'Layers',
    del: '‫حذف لایه‬',
    move_down: '‫انتقال لایه به پایین‬',
    new: '‫لایه جدید‬',
    rename: '‫تغییر نام لایه‬',
    move_up: '‫انتقال لایه به بالا‬',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: '‫انتقال عناصر به:‬',
    move_selected: '‫انتقال عناصر انتخاب شده به یک لایه متفاوت‬'
  },
  config: {
    image_props: '‫مشخصات تصویر‬',
    doc_title: '‫عنوان‬',
    doc_dims: '‫ابعاد صفحه مجازی (بوم)‬',
    included_images: '‫تصاویر گنجانده شده‬',
    image_opt_embed: '‫داده های جای داده شده (پرونده های محلی)‬',
    image_opt_ref: '‫استفاده از ارجاع به پرونده‬',
    editor_prefs: '‫تنظیمات ویراستار‬',
    language: '‫زبان‬',
    background: '‫پس زمینه ویراستار‬',
    editor_img_url: 'Image URL',
    editor_bg_note: '‫توجه: پس زمینه همراه تصویر ذخیره نخواهد شد.‬',
    select_predefined: '‫از پیش تعریف شده را انتخاب کنید:‬',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: '‫مقدار داده شده نامعتبر است‬',
    noContentToFitTo: '‫محتوایی برای هم اندازه شدن وجود ندارد‬',
    dupeLayerName: '‫لایه ای با آن نام وجود دارد!‬',
    enterUniqueLayerName: '‫لطفا یک نام لایه یکتا انتخاب کنید‬',
    enterNewLayerName: '‫لطفا نام لایه جدید را وارد کنید‬',
    layerHasThatName: '‫لایه از قبل آن نام را دارد‬',
    QmoveElemsToLayer: "‫عناصر انتخاب شده به لایه '%s' منتقل شوند؟‬",
    QwantToClear: '‫آیا مطمئن هستید که می خواهید نقاشی را پاک کنید؟\nاین عمل باعث حذف تاریخچه واگرد شما خواهد شد!‬',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: '‫در منبع SVG شما خطاهای تجزیه (parse) وجود داشت.\nبه منبع SVG اصلی بازگردانده شود؟‬',
    QignoreSourceChanges: '‫تغییرات اعمال شده در منبع SVG نادیده گرفته شوند؟‬',
    featNotSupported: '‫این ویژگی پشتیبانی نشده است‬',
    enterNewImgURL: '‫نشانی وب (url) تصویر جدید را وارد کنید‬',
    defsFailOnSave: 'NOTE: Due to a bug in your browser, this image may appear wrong (missing gradients or elements). It will however appear correct once actually saved.',
    loadingImage: 'Loading image, please wait...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Also note the following issues: ',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: "Retrieving '%s' ...",
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
